import React from 'react';
import { TIMEDEAL_WIDGET_LAYOUT_TYPE_V2, TimedealWidgetDetailV2 } from '../../../../../../types/widget';
import TimedealWidgetSwipeLayout from './TimedealWidgetSwipeLayout/TimedealWidgetSwipeLayout';
import Modal from '../../../../../../components/Modal';

interface TimedealWidgetPreviewModal {
  isOpen: boolean;
  detail: TimedealWidgetDetailV2;
  onClose: () => void;
}

const TimedealWidgetPreviewModal = (props: TimedealWidgetPreviewModal) => {
  const { isOpen, detail, onClose } = props;

  const getLayoutView = (detail: TimedealWidgetDetailV2) => {
    switch (detail.layoutType) {
      case TIMEDEAL_WIDGET_LAYOUT_TYPE_V2.SWIPE_1XN:
        return <TimedealWidgetSwipeLayout detail={detail} />;
    }
  };

  return (
    <Modal
      title={'위젯 미리보기'}
      wrapClassName="widget-preview-modal-wrapper"
      isOpen={isOpen}
      width={375}
      height={700}
      padding={'0px'}
      isFooter={true}
      okText="확인"
      onOk={onClose}
      onClose={onClose}
    >
      {isOpen && getLayoutView(detail)}
    </Modal>
  );
};

export default TimedealWidgetPreviewModal;
